<template>
	<div>
		<v-dialog ref="dialog_datepicker" no-click-animation v-model="datepicker" :return-value.sync="selectedDate" persistent lazy full-width width="290px" transition="slide-y-transition">
        	<v-date-picker v-model="selectedDate" :min="$root.minDateSelection" :max="$root.maxDateSelection" scrollable>
        		<v-spacer></v-spacer>
		        <v-btn flat color="primary" @click="$parent.fn_closeDialog">Cancel</v-btn>
		        <v-btn flat color="primary" :disabled="disableBtn" @click="fn_saveDate(selectedDate)">OK</v-btn>
        	</v-date-picker>
      	</v-dialog>
	</div>
</template>

<script>
let currentDateObj = new Date();


export default{
	props:['selected', 'updateDate'],
	data(){
		return{
			datepicker: false,
			selectedDate:new Date(),
			disableBtn:false
			// selectedDate:currentDateObj.getFullYear()+'-'+("0" + (currentDateObj.getMonth()+1)).slice(-2)+'-'+("0" + currentDateObj.getDate()).slice(-2)
		}
	},
	methods:{
		openDialogWeb: function () {
			// let dateObj = new Date(this.selected);
			let dateObj = null;
			if(this.selected){
				dateObj = new Date(this.selected);
			}
			else{
				dateObj = this.$parent.dateType == "start" ? new Date(this.$root.dataObj.startDate) : new Date(this.$root.dataObj.endDate);
			}
      		this.selectedDate = dateObj.getFullYear()+'-'+("0" + (dateObj.getMonth()+1)).slice(-2)+'-'+("0" + dateObj.getDate()).slice(-2);
			this.datepicker = true;
		},
		closeDialogWeb: function () {
			this.datepicker = false;
		},
		fn_saveDate: function (value) {
			this.disableBtn = true;
			let dateObj = new Date(value);
			this.$refs.dialog_datepicker.save(value);
			this.updateDate(dateObj);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dialogs/dialog_datepicker.vue